import React from "react";
import { Checkbox } from "@sonder/ui/source/styled/fragments/Checkbox";
import { CheckboxWithLabel } from "@sonder/ui/source/styled/fragments/CheckboxWithLabel";
import { Label } from "@sonder/ui/source/styled/fragments/Label";
import { setFilters, unsetFilters } from "tasks/actions";
import { FilterPair } from "tasks/helpers";
import { useSegmentQueue } from "tasks/hooks";
import { useStore } from "tasks/store";
import { TaskFilterInput } from "typings/globalGQLTypes";

interface FilterGroupItemProps {
  children?: React.ReactNode;
  label: string;
  segmentId: string;
  filters: TaskFilterInput;
  isActive?(props: FilterPair): boolean;
  onSetFilters?(nextFilters: TaskFilterInput): void;
  onUnsetFilters?(nextFilters: TaskFilterInput): void;
}
export const FilterGroupItem = ({
  children,
  label,
  segmentId,
  filters,
  isActive = () => false,
}: FilterGroupItemProps) => {
  const {
    state: { filters: globalFilters },
    dispatch,
  } = useStore();
  const pushToSegmentQueue = useSegmentQueue(globalFilters);
  const active = isActive({ globalFilters, localFilters: filters });

  return (
    <CheckboxWithLabel>
      <Checkbox
        checked={active}
        name={label}
        onClick={() => {
          if (active) dispatch(unsetFilters(filters));
          else dispatch(setFilters(filters));

          pushToSegmentQueue({
            eventName: "view_header",
            action: "click",
            element: segmentId,
            props: { nextValue: !active ? "selected" : "deselected" },
            commonProps: {},
          });
        }}
      />
      {children && <Label>{children}</Label>}
      {!children && label && <Label>{label}</Label>}
    </CheckboxWithLabel>
  );
};
